export default "__VITE_ASSET__7v1c7Qje__"